import api from "@/lib/api";

/**
 * Decides where to send a user right after they authenticate (login, register, or
 * Google OAuth callback), enforcing the hard payment gate: unpaid/lapsed users always
 * go to Billing first, before onboarding or the dashboard.
 */
export async function getPostAuthRedirect(user) {
  try {
    const { data } = await api.get("/billing/subscription");
    if (!data?.is_active) return "/billing";
  } catch (e) {
    return "/billing";
  }
  return user.onboarding_complete ? "/dashboard" : "/onboarding";
}
